import axios from 'axios';
import JsonApi from 'devour-client';
import { RateService } from './jsonapi/RateService';
import { ReservationService } from './ReservationService';
import { ParkService } from './jsonapi/ParkService';
import { SiteService } from './jsonapi/SiteService';
import { SiteTypeService } from './jsonapi/SiteTypeService';
import { VehicleLookupService } from './VehicleLookupService';
import { DiscountService } from './jsonapi/DiscountService';
import { GuestService } from './jsonapi/GuestService';
import { PaymentMethodService } from './jsonapi/PaymentMethodService';

const jsonApi = new JsonApi({ 
  apiUrl: 'https://dev-api.indioapp.com/api/v1', 
  bearer: null, 
  logger: false
});

class Services {
  static Park = new ParkService(jsonApi);
  static SiteTypes = new SiteTypeService(jsonApi);
  static Sites = new SiteService(jsonApi);
  static Guests = new GuestService(jsonApi);
  static VehicleLookups = new VehicleLookupService(jsonApi);
  static Rates = new RateService(jsonApi);
  static Discounts = new DiscountService(jsonApi);
  static Reservations = new ReservationService(jsonApi);
  static PaymentMethods = new PaymentMethodService(jsonApi);
}

export default Services;

export async function getToken() {
  const api = axios.create({ baseURL: 'https://dev-api.indioapp.com/api/v1' });
  const payload = {
    "data": {
      "type": "credentials",
      "attributes": {
        "email": "admin@lvh.me",
        "password": "asdasdasd"
      }
    }
  }

  const result = await api.post('user/login', payload);
  const token = result.data.data.attributes.token;
  jsonApi.bearer = token;
}
